
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'RequestAbout',
  props: {
  },
  setup () {
    const router = useRouter()

    return {
      router,

      scrollPage (page: string) {
        const scrollPage = document.getElementsByClassName('title ' + page)
        window.scrollTo({
          left: scrollPage[0].getBoundingClientRect().left,
          top: scrollPage[0].getBoundingClientRect().top - 10,
          behavior: 'smooth'
        })
      }
    }
  }
})
